/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module VrfContextModule
 */

import {
    Component,
    Input,
} from '@angular/core';

import { L10nService } from '@vmw/ngx-vip';
import { IItemGenericConfig } from 'ajs/modules/data-model/factories/item.factory';
import * as l10n from './vrf-context-modal-preview.l10n';
import './vrf-context-modal-preview.component.less';

const { ENGLISH: dictionary, ...l10nKeys } = l10n;

/**
 * @description VRF Context Modal Preview Component.
 * @author Sarthak Kapoor
 */
@Component({
    selector: 'vrf-context-modal-preview',
    templateUrl: './vrf-context-modal-preview.component.html',
})
export class VrfContextModalPreviewComponent {
    @Input()
    public readonly config: IItemGenericConfig;

    /**
     * Flag to hide/show Management VRF Context info on click of toggle icon.
     */
    public isExpanded = true;

    public readonly l10nKeys = l10nKeys;

    constructor(private readonly l10nService: L10nService) {
        l10nService.registerSourceBundles(dictionary);
    }

    /**
     * Handle toggle button click.
     */
    public onToggleButtonClick(): void {
        this.isExpanded = !this.isExpanded;
    }
}
